/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-trigger.js
 *
 * 指定クラスの位置までスクロールして,実行するアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { setCreateSpan } from "../setCreateSpan";

setCreateSpan();

//定義
let speed = 1;
const Trigger = document.querySelectorAll(".trigger");
const scrubTrigger = document.querySelectorAll(".scrubTrigger");
const scrubTriggerPc = document.querySelectorAll(".scrubTriggerPc");
const Fadein = document.querySelectorAll(".fadein");
const FadeinTrain = document.querySelectorAll(".fadein__train");
const SlideLeft = document.querySelectorAll(".slide__left");
const SlideUpTrain = document.querySelectorAll(".slide__up__train");
const Cover = document.querySelectorAll(".cover__create");

//シャッター要素生成
for (let i = 0; i < Cover.length; i++) {
	let createCover = document.createElement("span");
	createCover.className = "cover";
	Cover[i].appendChild(createCover);
}

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set([Fadein], {
	opacity: 0,
});
gsap.set([FadeinTrain], {
	opacity: 0,
});
gsap.set([SlideUpTrain], {
	yPercent: 50,
	opacity: 0,
});
gsap.set([SlideLeft], {
	xPercent: 50,
	opacity: 0,
});

/**
 * Trigger
 * 指定クラスの位置までスクロールして,実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setTrigger = () => {
	for (let i = 0; i < Trigger.length; i++) {
		gsap.to(Trigger[i].querySelectorAll(".fadein"), {
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 50%",
				toggleActions: "play none none reverse",
				//   markers: true,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".fadein__train"), {
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 50%",
				toggleActions: "play none none reverse",
				//   markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.7,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".slide__up__train"), {
			opacity: 1,
			yPercent: 0,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 50%",
				toggleActions: "play none none reverse",
				//   markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.7,
			},
		});
		gsap.to(Trigger[i].querySelectorAll(".slide__left"), {
			opacity: 1,
			xPercent: 0,
			duration: speed,
			scrollTrigger: {
				trigger: Trigger[i],
				start: "top 50%",
				toggleActions: "play none none reverse",
				//   markers: true,
			},
		});
	}

	const addFixed = document.getElementById("addFixed");
	const addFixedSp = document.getElementById("addFixedSp");
	const serviceNav = document.getElementsByClassName("service-nav");
	const DNavBtn = document.getElementById("d-nav-btn");

	ScrollTrigger.matchMedia({
		// 761px以上の場合
		"(min-width: 761px)": function () {
			ScrollTrigger.create({
				trigger: addFixed,
				start: "top top", // トリガーが画面の上部に来たとき
				onEnter: () => DNavBtn.classList.add("btnFixed"),
				onLeaveBack: () => DNavBtn.classList.remove("btnFixed"),
			});
			// ScrollTrigger.create({
			// 	trigger: serviceNav,
			// 	start: "top top", // トリガーが画面の上部に来たとき
			// 	onEnter: () => wrapper.classList.add("btnFixed"),
			// 	onLeaveBack: () => wrapper.classList.remove("btnFixed"),
			// });
			// ScrollTrigger.create({
			// 	trigger: access,
			// 	start: "top top", // トリガーが画面の上部に来たとき
			// 	onEnter: () => wrapper.classList.remove("btnFixed"),
			// 	onLeaveBack: () => wrapper.classList.add("btnFixed"),
			// });
		},
		// 760px未満の場合
		"(max-width: 760px)": function () {
			ScrollTrigger.create({
				trigger: addFixedSp,
				start: "top center", // トリガーが画面の上部に来たとき
				onEnter: () => DNavBtn.classList.add("btnFixed"),
				onLeaveBack: () => DNavBtn.classList.remove("btnFixed"),
			});
		},
	});

	const fixSpotNav = document.getElementById("fixSpotNav");
	const access = document.getElementById("access");

	if (fixSpotNav && access) {
		ScrollTrigger.matchMedia({
			// 761px以上の場合
			"(min-width: 761px)": function () {
				ScrollTrigger.create({
					trigger: access,
					start: "50% 75%", // トリガーが画面の上部に来たとき
					onEnter: () => fixSpotNav.classList.add("addHidden"),
					onLeaveBack: () => fixSpotNav.classList.remove("addHidden"),
					// markers: true,
				});
			},
			// 760px未満の場合
			"(max-width: 760px)": function () {
				ScrollTrigger.create({
					trigger: access,
					start: " bottom top", // トリガーが画面の上部に来たとき
					onEnter: () => fixSpotNav.classList.add("addHidden"),
					onLeaveBack: () => fixSpotNav.classList.remove("addHidden"),
					// markers: true,
				});
			},
		});
	}
	const sections = ["spot", "inn", "shop"];
	sections.forEach((section) => {
		const element = document.getElementById(section);
		const link = document.querySelector(`[data-section="${section}"]`);

		if (element && link) {
			ScrollTrigger.create({
				trigger: element,
				start: "top center",
				end: "bottom center",
				onEnter: () => link.classList.add("active"),
				onEnterBack: () => link.classList.add("active"),
				onLeave: () => link.classList.remove("active"),
				onLeaveBack: () => link.classList.remove("active"),
				// markers: true,
			});
		}
	});
};

/**
 * scrubTrigger
 * 指定クラスの位置からスクロール量で実行する
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setScrubTrigger = () => {
	for (let i = 0; i < scrubTrigger.length; i++) {
		gsap.to(scrubTrigger[i].querySelectorAll(".img .cover"), {
			scaleY: 0,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 50%",
				end: "40% 50%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".movie .cover"), {
			scale: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 50%",
				end: "40% 50%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".block__schedule .cover"), {
			opacity: 0.8,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 50%",
				end: "bottom 50%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.2,
			},
		});
		if (window.matchMedia("(min-width: 600px)").matches) {
			var startPotision = "40% 75%";
		} else {
			var startPotision = "top 75%";
		}
		gsap.to(scrubTrigger[i].querySelectorAll(".headline .span__create > span"), {
			translateY: 0,
			opacity: 1,
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: startPotision,
				end: "80% 50%",
				scrub: 1,
				// markers: true,
			},
			stagger: {
				from: "start",
				amount: 0.5,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".pinImg"), {
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 0%",
				end: "bottom 0%",
				scrub: 1,
				pin: true,
				// markers: true,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".coverImg"), {
			"--clip": "0",
			duration: speed,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 60%",
				end: "bottom 0%",
				scrub: 1,
				// markers: true,
			},
		});
		gsap.to(scrubTrigger[i].querySelectorAll(".scaleUp"), {
			duration: speed,
			//拡大させる
			scale: 1.2,
			scrollTrigger: {
				trigger: scrubTrigger[i],
				start: "top 60%",
				end: "bottom 0%",
				scrub: 1,
				// markers: true,
			},
		});
	}

	if (window.matchMedia("(min-width: 760px)").matches) {
	}
	for (let i = 0; i < scrubTriggerPc.length; i++) {
		gsap.to(scrubTriggerPc[i].querySelectorAll(".scaleUp--pc"), {
			duration: speed,
			//拡大させる
			scale: 1.2,
			scrollTrigger: {
				trigger: scrubTriggerPc[i],
				start: "top 60%",
				end: "bottom 0%",
				scrub: 1,
				// markers: true,
			},
		});
	}
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setTrigger, setScrubTrigger };
